<style scoped>
.cover-shape {
  position: absolute;
  left: 0;
  bottom: 0px;
  width: 100%;
  height: 20%;
  background-image: linear-gradient(
    90deg,
    rgb(255, 129, 103),
    rgb(235, 94, 65)
  );
}
.signin-form {
  min-width: 250px;
  max-width: 350px;
}
.signin-form img {
  width: 100%;
  height: 80px;
  object-fit: contain;
}
.cover-shape img {
  /* svg on an img tag */
  transform: rotate(180deg);
  width: 100%;
  position: absolute;
  top: -1px;
  left: 0px;
}
</style>
<style scoped>
.outlined {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
<template>
  <div class="fill-height">
    <div class="cover-shape">
      <img src="/img/accents/img.svg" />
    </div>
    <v-app-bar
      :clipped-left="primaryDrawer.clipped"
      app
      color="white"
      elevation="0"
      class="outlined"
    >
      <v-toolbar-title>
        <v-img
          src="https://images.static.arist.co/5d1315c147dda60e60b6d7b1/1567567119748_102585"
          max-height="50"
          contain
          position="left"
        ></v-img>
      </v-toolbar-title>
    </v-app-bar>
    <v-container fluid class="fill-height">
      <v-row>
        <v-col cols="12">
          <v-row
            align="center"
            justify="center"
            class="grey lighten-5"
            style="height: 100%"
          >
            <!-- <v-card class="ma-3 pa-6" outlined> </v-card> -->
            <v-card flat="" outlined="">
              <v-card-title
                >Join {{ $store.getters["getOrganization"].name }}</v-card-title
              >
              <div v-if="email">
                <v-window v-model="step">
                  <v-window-item :value="2">
                    <a-signin
                      @signup="step = 1"
                      :key="step"
                      :forceemail="email"
                      @success="onSuccess"
                  /></v-window-item>
                  <v-window-item :value="1">
                    <a-signup
                      @signin="step = 2"
                      :key="step"
                      :forceemail="email"
                      @success="onSuccess"
                  /></v-window-item>
                </v-window>
              </div>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import signInComponent from "@/components/signin";
import signUpComponent from "@/components/signup";
import services from "@/services/index.js";
import userActions from "@/bin/aws/userActions";
import generateUser from "@/bin/aws/generateUser";
import bugsnagClient from "@/plugins/bugsnag";
export default {
  components: {
    "a-signin": signInComponent,
    "a-signup": signUpComponent
  },
  props: ["code"],
  data() {
    return {
      step: 1,
      email: null,
      // Navigation bar
      primaryDrawer: {
        model: null,
        clipped: true,
        floating: false,
        mini: false
      },
      alignment: "center",
      dense: false,
      justify: "center"
    };
  },
  methods: {
    async onLoad() {
      //TODO make this better
      try {
        try {
          this.$ga.event({
            eventCategory: "dashboard-invite",
            eventAction: "attempting",
            eventLabel: "Dashboard"
          });
        } catch (err) {
          console.error("[GA]", err);
        }
        await userActions.signout();
        if (!this.code) {
          this.$router.push({ path: "/notfound" });
          return;
        }
        let response = await services.invite.getDetails({ token: this.code });
        if (!response || !response.email) {
          //TODO ERROR
          try {
            this.$ga.event({
              eventCategory: "dashboard-invite",
              eventAction: "invalid-invite",
              eventLabel: "Dashboard"
            });
          } catch (err) {
            console.error("[GA]", err);
          }
          this.$router.push({ path: "/notfound" });
        }
        if (response.email) {
          this.email = response.email;
        }
        try {
          this.$ga.event({
            eventCategory: "dashboard-invite",
            eventAction: "valid-invite",
            eventLabel: "Dashboard"
          });
        } catch (err) {
          console.error("[GA]", err);
        }
      } catch (err) {
        bugsnagClient.notify(err, {
          metaData: {
            token: this.code
          }
        });
        this.$router.push({ path: "/notfound" });
      }
    },
    async onSuccess() {
      console.log("[Invite]");
      this.$store.commit("setLoading", true);
      try {
        try {
          this.$ga.event({
            eventCategory: "dashboard-invite",
            eventAction: "attempt-invite-accept",
            eventLabel: "Dashboard"
          });
        } catch (err) {
          console.error("[GA]", err);
        }
        await services.invite.acceptInvite({ token: this.code });
        console.log("[Invite]", "Done sending updating permissions");
        try {
          this.$ga.event({
            eventCategory: "dashboard-invite",
            eventAction: "invite-accepted",
            eventLabel: "Dashboard"
          });
        } catch (err) {
          console.error("[GA]", err);
        }
        //refresh the user
        await generateUser({ override: true });
        console.log("[Invite]", "Done updating user");
        try {
          this.$ga.event({
            eventCategory: "dashboard-invite",
            eventAction: "invite-redirect",
            eventLabel: "Dashboard"
          });
        } catch (err) {
          console.error("[GA]", err);
        }
        window.location = "/";
      } catch (err) {
        console.error("[Invite] ERROR", err);
        this.$router.push({ path: "/notfound" });
        try {
          this.$ga.event({
            eventCategory: "dashboard-invite",
            eventAction: "failed-invite-accept",
            eventLabel: "Dashboard"
          });
        } catch (err) {
          console.error("[GA]", err);
        }
        //TODO Error
      } //TODO Better error handling
      this.$store.commit("setLoading", false);
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>
<style></style>
